import {makeStyles} from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    container: {
      padding: 20,
      '& .title': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 20,
        marginBottom: 20,
      },
      '& .label': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 14,
        marginBottom: 20,
      },
    },
    agreementsContainer: {
      padding: 20,
      marginTop: 15,
      '& .title': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 20,
        marginBottom: 20,
      },
      '& .label': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 14,
        marginBottom: 20,
      },
      '& li': {
        listStyleType: "square",
        textDecoration: "underline",
        color: "#292991",
        cursor: "pointer",
        marginBottom: 5,

        '&::marker': {
          fontSize: 20,
          color: "#989898"
        },
      },
    },
    filenameText: {
      textDecoration: "underline",
      cursor: "pointer"
    }
  }));
  return styles();
}
export default theme;

